// @flow

import TextArea from './TextArea'

export default TextArea
